import { render, staticRenderFns } from "./sendSmsMessageContent.vue?vue&type=template&id=cf681766&scoped=true"
import script from "./sendSmsMessageContent.vue?vue&type=script&lang=js"
export * from "./sendSmsMessageContent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cf681766",
  null
  
)

export default component.exports